import { ICandidateDetails, IInputFields } from './index';
import { IWelcomePageSettingsJobResponse } from './welcomePageTypes';

interface IJobConfig {
  hideQuestions: boolean;
  practice: boolean;
}
// TODO: Same interface for data dat we get from the back and data that we send

export interface IParsedInputField {
  [key: string]: {
    value: string;
    type: string;
  }
}
export interface ICandidate {
  candidate_id: string;
  company_id: string;
  deadline: string;
  email: string;
  isPublic: boolean;
  jobID: string;
  job_id: string;
  link: string;
  location: string;
  phone: string;
  status: string;
  timezoneForInvite: string;
  username: string;
}
export interface IJobQuestion {
  numOfRetakes: number;
  partDuration: number;
  question: string;
  thinkingTime: number;
}
export interface IJob {
  apiKey: string;
  backgroundImage: string;
  company: string;
  companySlug: string;
  company_id: string;
  config: IJobConfig;
  creatorEmail: string;
  creatorId: string;
  deadlineDate: string | null;
  experience: string;
  id: string;
  introVideo: string | null;
  outroVideo?: string;
  thankYouMsg?: string;
  isFake: boolean;
  isPreview?: boolean;
  jobDescription: string;
  jobID: string;
  job_id: string;
  jobInputFields: IInputFields[],
  language: 'ar' | 'en' | 'fr' | 'de' | 'he' | 'ko' | 'pt' | 'es' | 'cn';
  logo: string;
  overlay: string;
  privacyUrl: string;
  questions: IJobQuestion[];
  skills: string[];
  slug: string;
  status: 'active' | 'archived' | 'draft';
  termsUrl: string;
  title: string;
  transcriptLanguage: 'en-GB' | 'fr-FR' | 'de-DE' | 'he-IL' | 'ko-KR' | 'pt-PT' | 'es-ES' | 'zh-CN';
  uploadCV: false;
  welcomePageSettings?: IWelcomePageSettingsJobResponse;
  practiceQuestions?: IJobQuestion[];
}

export interface IVideoPlatformOS {
  architecture: number;
  family: string;
  version: string;
}

export interface IVideoPlatform {
  description: string;
  layout: string;
  manufacturer: string;
  name: string;
  prerelease: string;
  product: string;
  ua: string;
  version: string;
  os: IVideoPlatformOS;
}

export interface IVideoFile {
  completed: boolean; // const false, <updateable>
  uploaded: boolean; // const false, upadted automaticlly
  filename: string; // <new>
  retakes: number; // const 0, <updateable>
  started: boolean; // const false, <updateable>
  videoLength?: number; // none <updateable>
  uploadUrl?: string; // <new>
  question?: string; // job -> suggested
  //   transcoded: boolean; // none
  //   transcodingError?: string; // none
  //   type?: string; // none
  //   isAndroidSdk?: boolean; // suggested -> const false, <updateable>
  //   exported?: boolean; // none
  //   isMobile?: boolean; // suggested -> none, <updateable>
  //   rescued?: boolean; // none
  //   hasTranscript?: boolean; // none
  //   fileId?: string; // none
  //   renamed?: boolean; // none
  //   sources?: { // none
  //     src: string;
  //     type: string;
  //   }; // none
  //   transcript?: ITranscript | string; // none
  //   language?: string; // job -> suggested
  //   thumbnail?: string; // none
  //   poster?: string; // none
  //   textTracks?: { // none
  //     kind: string;
  //     label: string;
  //     language: string;
  //     src: string;
  //     default: boolean;
  //   }[]; // none
}

export interface IVideo {
  video_id: string; // trusted candidate -> <new>
  bandwidth?: string; // suggested <updateable>
  clicked?: boolean; // const true
  started?: boolean; // const false
  completed?: boolean; // const false (when creating, when patching verify and toggle) <updateable>
  uploaded?: boolean; // const false (when creating, when patching verify and toggle)
  jobID?: string; // {deprecated} candidate -> job -> suggested(must be checked) -> <load default job> -> <new default job>
  platform?: IVideoPlatform; // suggested <updateable>
  quality?: string; // suggested <updateable>
  referrer?: string; // suggested <updateable>
  cvUrl?: string; // suggested
  videos: IVideoFile[]; // build from job -> untrasted job -> suggested
  processTime?: number; // suggested
  files?: string[]; // suggested
  personalInfo?: Record<string, string>; // suggested fields
  language?: string; // candidate -> job -> apiKey -> suggested
  gdprTimestamp?: string; // sugested -> <now> <updatable>
  tracking?: {
    reminder: number;
    source: number;
  };
  //   job_id: string; // candidate -> job -> suggested(must be checked) -> <load default job> -> <new default job>
  //   apiKey: string; // apiKey!
  //   company_id: string; // apiKey!
  //   sharing_enabled: boolean; // unknown, so const true
  //   email: string; // candidate -> suggested
  //   ip: string; // <REQ>
  //   location: string; // const 'US'
  //   role: string; // unknown, but seems to be arbitrary from suggested
  //   region: string; // const 'us' (only the US has the correct bucket)
  //   serverVersion: string; // const <PKG_VERSION> + 1
  //   username: string; // candidate -> suggested
  //   shareCode: string; // <new>
  //   toDelete: boolean; // none
  //   isFake: boolean; // const false
  //   isPublic: boolean; // candidate -> const true
  //   isDev: boolean; // <ENV>
  //   webhookSavedSuccess?: boolean; // none
  //   webhook: IVideoWebhook; // none
  //   deleted?: boolean; // none
  //   filesAnalytics?: string; // unknown, const []
  //   candidate_id: string; // candidate -> suggested (with job/company verification) -> <new>
  //   run: boolean; // unknown, so const false
  //   time_viewed: number; // const 0
  //   notes: INote[]; // const []
  //   likes: IVideoLike[]; // const []
  //   commentsArr: IVideoComment[]; // const []
  //   ratingsArr: IVideoRating[]; // const []
  //   personalities?: ITextEmotions; // none
  //   ranking?: number; // unknowen, so none
  //   candidate_location: string; // resolve from IP
  //   limit: {
  //     isOverLimit: boolean;
  //     length: number;
  //   }; // none!
  //   unlockedAt?: Date; // none!
  //   status: string; // const 'candidate'
  //   statusId?: string; // kanban col id: job(default) -> none
  //   integration_id?: string; // candidate -> job -> none
  //   integration_name?: string; // candidate -> job -> none
  //   updatedAt: Date | string | number; // const <now>
  //   createdAt: Date | string | number; // const <now>
}

export enum CandidateStatus {
  PENDING = 'pending',
  CLICKED = 'clicked',
  STARTED = 'started',
  COMPLETED = 'completed',
  DELETED = 'deleted',
  UPLOADING = 'uploading',
}

export interface IJobResponse {
  event_id?: string;
  session_id?: string;
  candidate? : ICandidate;
  showWatermark?: boolean;
  subscription?: {
    status?: string | '',
    plan_name?: string
  };
  usages? : IUsage;
  job: IJob;
  widgetAuthorizationSignature: string;
  status: CandidateStatus;
  quizDetails?: ICandidateDetails;
  language?: string;
  logo?: string;
  transcriptLanguage?: string;
  video?: IVideo;
}
interface IUsage {
  job: number;
  candidate: number;
  live: number;
  user: string;
}
